module.exports = __webpack_public_path__ + "img/box-arrow-in-up-right.e9d4e87e.svg";